import { Routes, Route, useParams, useLocation } from "react-router-dom";

import MainPage from "../../pages/MainPage";
import AboutUsPage from "../../pages/AboutUsPage";
import CategoriesPage from "../../pages/CategoriesPage";
import ProductsPage from "../../pages/ProductsPage";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Box, Flex } from "@chakra-ui/react";
import Login from "../../pages/Login";
import Signup from "../../pages/Signup";
import ComingSoonPage from "../../pages/ComingSoonPage";
import ConfirmEmailPage from "../../pages/ConfirmEmailPage";
import { useEffect } from "react";
import ForgotPassword from "../../pages/ForgotPassword";
import getUserFromLocalStorage from "../../utils/getUsetFromLocalStorage";
import { transformUserData } from "../../utils/transformUserData";
// import LoginToAllSite from "../LoginToAllSite/LoginToAllSite";
import SearchPage from "../../pages/SearchPage";
import { Helmet } from "react-helmet";
import { useAtom } from "jotai";
import { rememberUser, userInfoAtom } from "../../atom/user";
import FaqPage from "../../pages/Faq";
import VendorRegistration from "../../pages/VendorRegistration";

import Giveaway from "../../pages/Giveaway";
import ShotShowPage from "../../pages/ShotShowPage";
import {
  useGlobalEventListeners,
  usePageTracking,
} from "../../utils/analytics";
import ContactUs from "../../pages/CountactUs";
import { data } from "../../data";
import MainPageStorylaneOverlay from "../MainPageSections/MainPageStorylaneOverlay";
import useSiteStatus from "../../hooks/useSiteStatus";

import TermsAndPrivacy from "../../pages/TermsAndPrivacy";
import GiveawayTermsAndPrivacy from "../../pages/GiveawayTermsAndPrivacy";
import SeoRedirectHandler from "../SeoRedirectHandler/SeoRedirectHandler";
import { URL_TYPES, ROUTE_PATTERNS } from "../../constants/seoUrlPatterns";
import { useFacetMeta } from "../../hooks/useFacetMeta";
import NotFound from "../../pages/NotFound";
import BrandsPage from "../../pages/BrandsPage";
import MaintenancePage from "../../pages/MaintenancePage";
import useMaintenanceStatus from "../../hooks/useMaintenanceStatus";

function App() {
  const [, setUserId] = useAtom(userInfoAtom);
  const [rememberMe] = useAtom(rememberUser);
  const { fetchData } = useFacetMeta();

  const location = useLocation();

  usePageTracking();
  useGlobalEventListeners();
  useSiteStatus();

  useMaintenanceStatus();

  usePageTracking();
  useGlobalEventListeners();

  useEffect(() => {
    getUserFromLocalStorage(rememberMe)
      .then((attributes) => {
        setUserId(transformUserData(attributes));
      })
      .catch((err) => {});

    // Initialize facet_meta data for SEO URL generation
    fetchData().catch((err) =>
      console.error("Failed to fetch facet_meta:", err),
    );

    // eslint-disable-next-line
  }, []);

  const DynamicRouteHandler = () => {
    const { slug } = useParams();

    const categories = data.map(({ categoryLink }) => categoryLink);

    if (slug && categories.includes(slug)) {
      return <CategoriesPage />;
    }

    return <ProductsPage slider />;
  };

  // Handler for product detail URLs (pattern: /{slug}-{productId})
  // These URLs should render ProductsPage with slider=true
  const ProductDetailHandler = () => {
    const { slug } = useParams();

    if (!slug) {
      return <SeoRedirectHandler />;
    }

    // 1. Category pages: something-ammo (no product ID)
    if (/^[a-z0-9-]+-ammo$/.test(slug)) {
      return <CategoriesPage />;
    }

    // 2. Product detail pages: ends with -{id}
    if (/^(.+)-(\d+)$/.test(slug)) {
      return <ProductsPage slider />;
    }

    // 3. Fallback
    return <SeoRedirectHandler />;
  };

  const isMaintenancePage = location.pathname === "/maintenance";
  return (
    <Flex flexDirection={"column"} minH={"100%"}>
      <Helmet>
        <title>
          BulletScout | Compare Ammunition Prices, Find Cheap Ammo | 2025
        </title>
        <meta
          name="description"
          content="Premier ammo search engine for finding the cheapest ammunition prices online in 2025. Rifle, pistol, rimfire, and shotgun ammo in bulk."
        />
      </Helmet>
      {/* <LoginToAllSite /> */}
      {!isMaintenancePage && <Header />}

      <Box flex={"1 1 auto"}>
        {/* <DemoBanner /> */}
        <Routes>
          <Route path="maintenance" element={<MaintenancePage />} />
          <Route path="/" element={<MainPage />} />
          <Route path="about-us" element={<AboutUsPage />} />

          {/* New SEO Routes - Point to ProductsPage */}
          <Route path="/ls/*" element={<ProductsPage />} />
          <Route path="/pd/*" element={<ProductsPage />} />
          <Route path="/brands" element={<BrandsPage />} />

          <Route path="/brands/:slug" element={<DynamicRouteHandler />} />

          {/* Static Routes */}
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="registration" element={<VendorRegistration />} />
          <Route path="coming-soon" element={<ComingSoonPage />} />
          <Route path="confirm-email/:userSub" element={<ConfirmEmailPage />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="giveaway" element={<Giveaway />} />
          <Route path="shotshow" element={<ShotShowPage />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="terms-and-privacy" element={<TermsAndPrivacy />} />
          <Route path="not-found" element={<NotFound />} />
          <Route
            path="giveaway-terms-and-conditions"
            element={<GiveawayTermsAndPrivacy />}
          />
          <Route
            path="demo"
            element={
              <Box mt={"50px"}>
                <MainPageStorylaneOverlay />
              </Box>
            }
          />

          {/* Product detail URLs: /{slug}-{productId} - render ProductsPage with slider */}
          <Route path=":slug" element={<ProductDetailHandler />} />

          {/* Catch-all route for old URLs - redirect to new SEO URLs */}
          <Route path="*" element={<SeoRedirectHandler />} />
        </Routes>
      </Box>
      {!isMaintenancePage && <Footer />}
    </Flex>
  );
}

export default App;
